import CustomInput from "@/components/CustomInput.vue";
import CustomSelect from "@/components/CustomSelect.vue";
import CustomDatePicker from "@/components/CustomDatePicker.vue";
import CustomDialog from "@/components/CustomDialog.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomPanel from "@/components/CustomPanel.vue";
import SelectDialog from "@/components/SelectDialog.vue";
import Copyright from "@/components/Copyright.vue";
import Logo from "@/components/Logo.vue";
import Wrapper from "@/components/Wrapper.vue";
import { App } from "vue";

export default (app: App<Element>) => {
  app
    .component("cus-input", CustomInput)
    .component("cus-dialog", CustomDialog)
    .component("cus-table", CustomTable)
    .component("cus-select", CustomSelect)
    .component("cus-date-picker", CustomDatePicker)
    .component("cus-panel", CustomPanel)
    .component("select-dialog", SelectDialog)
    .component("copyright", Copyright)
    .component("logo", Logo)
    .component("wrapper", Wrapper);
};
